module.exports = {"id":"188337","name":"Mubarak Wakaso","rating":"74","photo":"./data/images/photos/2/188337.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["MC","MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MubarakWakaso0.json
// module id = 3099
// module chunks = 0